<template>
  <div>
    <ConfirmationDialog ref="confirm" :function-yes="bindingFunction"></ConfirmationDialog>
    <ApprovedCriteriosDialog ref="notification" :criterios="criterioNotification"></ApprovedCriteriosDialog>
    <v-btn :disabled="!estadoPermissions.canApprove" color="#1787c9" class="white--text" @click="approve">Aprobar</v-btn>
    <v-btn :disabled="!estadoPermissions.canPartialApprove" color="#1787c9" class="white--text" @click="partialApprove">Aprobar parcialmente</v-btn>
    <v-btn :disabled="!estadoPermissions.canRefuse" color="#1787c9" class="white--text" @click="refuse">Rechazar</v-btn>
  </div>
</template>

<script>
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import ApprovedCriteriosDialog from './ApprovedCriteriosDialog'

export default {
  props: {
    estadoPermissions: Object
  },
  components: {
    ConfirmationDialog,
    ApprovedCriteriosDialog
  },

  data () {
    return {
      bindingFunction: null,
      criterioNotification: {}
    }
  },

  methods: {
    approve () {
      this.bindingFunction = () => {
        this.axios
          .put(`/update-presentation/approve/${this.$route.params.id}`)
          .then(() => this.$router.push({ name: 'actualizaciones' }))
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      }
      this.$refs.confirm.openDialog()
    },
    partialApprove () {
      this.bindingFunction = () => {
        this.axios
          .put(`/update-presentation/partial-approve/${this.$route.params.id}`)
          .then(response => {
            this.criterioNotification = response.data
            this.$refs.notification.openDialog()
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      }
      this.$refs.confirm.openDialog()
    },
    refuse () {
      this.bindingFunction = () => {
        this.axios
          .put(`/update-presentation/refuse/${this.$route.params.id}`)
          .then(() => this.$router.push({ name: 'actualizaciones' }))
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      }
      this.$refs.confirm.openDialog()
    }
  }
}
</script>
